import { useStyles } from './products.styles';
import { IProductsProps } from './products.models';
import { ProductCard } from '../product-card';
import { ProductOwnerType } from '../../../../../../graphql/order/models/get-orders.models';
import { useDependentColors } from '../../../../../../hooks/use-dependent-colors';

export const Products = ({ products, hasKidProfiles = false }: IProductsProps): JSX.Element => {
  const classes = useStyles();
  const { getDependentColorIndex } = useDependentColors();

  return (
    <>
      {products.length && (
        <ul className={classes.list} data-testid="products" role="list">
          {products.map((product, index) => {
            const productOwner = product.productOwner;
            const profile = productOwner?.profile;
            const isConsumer = hasKidProfiles && productOwner?.type === ProductOwnerType.consumer;
            const profileColorIndex =
              productOwner?.type === ProductOwnerType.dependent &&
              profile?.firstName &&
              profile?.lastName
                ? getDependentColorIndex(profile.firstName, profile.lastName)
                : undefined;
            return (
              <li key={index} className={classes.item} role="listitem">
                <ProductCard
                  brand={product.brand}
                  packSize={product.packSize}
                  productQuantity={product.productQuantity}
                  productOwnerType={productOwner?.type}
                  profileFirstName={isConsumer ? 'Consumer' : profile?.firstName}
                  profileLastName={isConsumer ? '' : profile?.lastName}
                  profileIsActive={profile?.isActive ?? true}
                  profileColorIndex={profileColorIndex}
                  hasKidProfiles={hasKidProfiles}
                  isDeleted={!profile}
                />
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};
